import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import ButtonLink from 'components/Buttons/Link';
import { useTranslation } from 'react-i18next';
import { useSubscriptionProps } from '../../Billing/useSubscriptionProps';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { DirectorAddLicences } from './DirectorAddLicences';
import { usePendingTransferProps } from './usePendingTransferProps';
import { PayByBankTransferModal } from './PayByBankTransferModal';
import { PendingBankTransferModal } from './PendingBankTransferModal';

export function DirectorAddLicencesPage() {
  const { t } = useTranslation(['userSettings']);
  const subscriptionProps = useSubscriptionProps();
  const { openPayByBankTransferModal } =
    usePendingTransferProps(subscriptionProps);
  return (
    <TwoColumnsCardSidebar.Container>
      <PayByBankTransferModal />
      <PendingBankTransferModal />
      <ButtonLink
        to="/direction/school-subscription/licenses"
        minimal
        icon={ArrowLeftIcon}
        tw="mb-4"
      >
        {t('userSettings:schoolSubscription.goToLicenses')}
      </ButtonLink>
      <DirectorAddLicences
        onPayByBankTransfer={openPayByBankTransferModal}
        {...subscriptionProps}
      />
    </TwoColumnsCardSidebar.Container>
  );
}
